import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/dashboard/health_sync_card.vue'

export default class extends Controller {
  static values = {
    userId: String
  }

  connect() {
    const props = {
      userId: this.userIdValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
